import * as React from 'react';
import { motion } from 'framer-motion';
import { Users, Sprout, Shirt } from 'lucide-react';
import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';
import './App.css';
import ProductPage from './ProductPage';

const products = [
  {
    id: 'panangarkandu',
    name: 'பனங்கற்கண்டு',
    image: '/Sugar.jpg',
    description: `
      
    `
  }
];

function App() {
  const [showChatbot, setShowChatbot] = React.useState(false);
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/product/:id" element={<ProductPage products={products} />} />
      </Routes>
    </Router>
  );
}

function Home() {
  const [showChatbot, setShowChatbot] = React.useState(false);
  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-r from-green-500 to-yellow-600">
      <main className="text-center text-white p-8 max-w-8xl w-full flex justify-center">
        <div className="bg-white/20 backdrop-blur-lg rounded-2xl p-12 shadow-2xl border border-white/30 w-full max-w-6xl">
          <img
            src="/Logo_Kittu.jpg"
            alt="Kittu Logo"
            className="logo mx-auto mb-8 rounded-full bg-white/30 p-4 shadow-md" // Applied custom class
          />
          <h1 className="text-5xl font-extrabold mb-4 drop-shadow-lg">About Us</h1>
<p className="text-lg mb-8 leading-relaxed">
  Welcome to our platform, dedicated to the teachings and legacy of <strong>Marabu Vaazhvil Mahaan Deivathiru Kittu Ayya</strong>. 
  A revered figure deeply connected to nature, Kittu Ayya viewed trees as deities and lived harmoniously with the environment. 
  Throughout his life, he extended help to many and contributed positively to society. 
  Our mission is to share his wisdom and promote a lifestyle that embraces traditional values and natural living.
</p>
<h2 className="text-2xl font-semibold mb-4">Our Services</h2>
<ul className="text-lg list-disc list-inside mb-8">
  <li><strong>Kittu Ayya Marabu Arakkattalai:</strong> An initiative to preserve and propagate the traditional lifestyle and teachings of Kittu Ayya, emphasizing harmony with nature.</li>
  <li><strong>Agathiyar Naatu Marunthu Kadai:</strong> Offering a range of herbal remedies and natural medicines rooted in ancient practices, aimed at promoting health and well-being.</li>
  <li><strong>Thugil Aadaiyagam:</strong> Providing high-quality traditional garments, encouraging the adoption of cultural attire in daily life.</li>
</ul>
<p className="text-lg">
  We invite you to explore our offerings and join us in embracing a lifestyle that honors our rich heritage and the wisdom of our ancestors.
</p>

          
          {/* Services Section */}
          <section className="mb-8 border-b border-white/20 pb-8">
            
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 mt-6">
              <motion.div
                className="bg-white/10 p-6 rounded-lg text-center shadow-md"
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.4 }}
              >
                <img 
                  src="/Logo_Kittu.jpg" 
                  alt="Kittu Logo" 
                  className="w-[40px] h-[40px] mx-auto mb-3 object-contain" 
                />
                <h3 className="text-lg font-semibold">கிட்டு ஐயா மரபு அறக்கட்டளை</h3>
                <span className="inline-block mt-3 px-3 py-1 bg-green-500 text-white font-bold rounded-full text-sm shadow-md">
                  Active Service
                </span>
                <p className="text-sm opacity-80 mt-2">
                 கிட்டு ஐயா என்பவர் இயற்கையை நேசிக்கும், மரபு வாழ்வியல் மகான் ஆவார்.  
  இவர் மரங்களை தெய்வமாகக் கருதி, இயற்கையோடு இணைந்து வாழ்ந்தவர்!  
  அவர் வாழ்வில் பலருக்கு உதவினார், சமூகத்திற்கு நன்மைகளைப் வழங்கினார்!🌿✨
                </p>
                
              </motion.div>
    
              <motion.div
                className="bg-white/10 p-6 rounded-lg text-center shadow-md"
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.5 }}
              >
                <Sprout size={40} className="mx-auto text-green-300 mb-3" />
                <h3 className="text-lg font-semibold">அகத்தியர் நாட்டு மருந்து கடை</h3>
                <span className="inline-block mt-3 px-3 py-1 bg-green-500 text-white font-bold rounded-full text-sm shadow-md">
                  Active Service
                </span>
                <p className="text-sm opacity-80 mt-2">நோய் தீர்க்கும் மூலிகை உணவு மருந்து வகைகள்</p>
                <Link 
                 to="/product/panangarkandu" 
                 className="mt-3 px-6 py-3 bg-gradient-to-r from-yellow-400 to-red-500 text-white rounded-lg hover:from-red-500 hover:to-yellow-400 animate-pulse shadow-lg text-lg font-bold inline-block"
                  >
                 Products
                 </Link>

              </motion.div>
    
              <motion.div
                className="bg-white/10 p-6 rounded-lg text-center shadow-md"
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.6 }}
              >
                <Shirt size={40} className="mx-auto text-green-300 mb-3" />
                <h3 className="text-lg font-semibold">துகில் ஆடையகம்</h3>
                <span className="inline-block mt-3 px-3 py-1 bg-green-500 text-white font-bold rounded-full text-sm shadow-md">
                  Active Service
                </span>
                <p className="text-sm opacity-80 mt-2">
                   தரமான துணிகள் வாங்க..!
                   துகிலுக்கு வாங்க..!!
                </p>
                
              </motion.div>
            </div>
          </section>
          {/* Video Section */}
<div className="mt-8 text-center">
  <h2 className="text-2xl font-semibold mb-4 text-white">தமிழன் கிட்டு. காசிராமன்</h2>
  <iframe 
    src="https://customer-zur2k0r44n3vzlo3.cloudflarestream.com/00bec7a62f25251cd7626b262d2de4ca/iframe" 
    className="w-full max-w-3xl h-64 sm:h-96 mx-auto rounded-lg shadow-lg"
    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
    allowFullScreen
  ></iframe>
</div>

          
          {/* Chatbot Link and Popup */}
          <button
            onClick={() => setShowChatbot(true)}
            className="mt-4 text-sm text-white underline hover:text-gray-300"
          >
            மரபு வாழ்வியல் மகான் தெய்வத்திரு கிட்டு ஐயா ChatBot
          </button>
          <p className='mt-6 text-sm text-white opacity-75 text-center w-full'> <a href='https://wa.me/919345076362/' className='underline hover:text-gray-300'>மரபு வாழ்வியல் மகான் தெய்வத்திரு கிட்டு ஐயா WhatsApp AI</a></p>
          <p className='mt-6 text-sm text-white opacity-75 text-center w-full'>Powered by <a href='https://minimenu.ca/' className='underline hover:text-gray-300'>MiniMenu.ca</a></p>
          {showChatbot && (
            <div className="fixed bottom-10 right-10 w-full max-w-[400px] sm:max-w-[500px] bg-black/50 rounded-lg shadow-lg">
              <div className="bg-white p-6 rounded-lg shadow-lg max-w-full sm:max-w-lg w-full">
                <iframe src="https://kittu-ai.pthamiz.workers.dev/" className="w-full h-[80vh] sm:h-[500px] mt-4 border border-gray-300 rounded-lg"></iframe>
                <button
                  onClick={() => setShowChatbot(false)}
                  className="mt-4 bg-red-500 text-white px-4 py-2 rounded-lg hover:bg-red-400"
                >
                  Close
                </button>
              </div>
            </div>
          )}
        </div>
       </main>
    </div>
  );
}

export default App;
